import React, { useState } from 'react'
import type { SliderProps } from 'rc-slider'
import { Tooltip } from '@mui/material'

interface HandleTooltipProps {
  value: number
  children: React.ReactElement
  visible: boolean
  tipFormatter?: (value: number) => React.ReactNode
}

export const HandleTooltip: React.FC<HandleTooltipProps> = props => {
  const { value, children, visible: propsVisible, tipFormatter = val => `${val} %`, ...restProps } = props

  const [isHovered, setIsHovered] = useState(false)

  const childrenWithHover = React.cloneElement(
    children as React.ReactElement<{
      onMouseEnter?: () => void
      onMouseLeave?: () => void
    }>,
    {
      onMouseEnter: () => setIsHovered(true),
      onMouseLeave: () => setIsHovered(false)
    }
  )

  return (
    <Tooltip
      open={propsVisible || isHovered}
      title={tipFormatter(value)}
      placement='bottom'
      PopperProps={{
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, 8]
            }
          }
        ]
      }}
      slotProps={{
        popper: {
          sx: {
            zIndex: 1300
          }
        },
        tooltip: {
          sx: {
            bgcolor: 'transparent'
          }
        }
      }}
    >
      {childrenWithHover}
    </Tooltip>
  )
}
